import * as React from 'react'
import { AutoSizer } from 'react-virtualized'

export enum ReleaseNotesScope {
  All = 'all',
  Major = 'major',
  Minor = 'minor',
  Patch = 'patch',
}

export interface IReleaseNotesViewerProps {
  parcelId: string
  scope?: ReleaseNotesScope
  version: string
}

export class ReleaseNotesViewer extends React.PureComponent<
  IReleaseNotesViewerProps
> {
  public render() {
    const releaseNotesUrl = `https://parcelapp.io/api/projects/${
      this.props.parcelId
    }/notes/format/html`

    const query = [
      `version=${encodeURIComponent(this.props.version)}`,
      'raw=true',
    ]

    if (this.props.scope) {
      query.push(`scope=${encodeURIComponent(this.props.scope)}`)
    }

    return (
      <AutoSizer>
        {({ height, width }) => (
          // Safari on iOS works differently than all other browsers. Apple in all it's wisdom ignores the height set on
          // an iframe and autosizes the iframe to fit the content. The relative positioned div and absolutely positioned
          // iframe is a work around to get iOS to work like other browsers.
          <div
            style={{ height, width, overflow: 'auto', position: 'relative' }}
          >
            <iframe
              height={height}
              src={`${releaseNotesUrl}?${query.join('&')}`}
              style={{
                border: 'none',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
              }}
              width={width}
            />
          </div>
        )}
      </AutoSizer>
    )
  }
}
